import script from "./SearchComp.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchComp.vue?vue&type=script&setup=true&lang=js"

import "./SearchComp.vue?vue&type=style&index=0&id=6dfa7058&lang=scss&scoped=true"

import exportComponent from "/Users/ttheitao/Desktop/devApps/onetab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dfa7058"]])

export default __exports__